import { useAsObservableSource } from 'mobx-react-lite';
import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { CompetitionEventName } from 'src/domains/sportsbook/trading/view/eventDetails/eventSettings/EventSettingsElements/CompetitionEventName';
import { ParticipantsEventSettings } from 'src/domains/sportsbook/trading/view/eventDetails/eventSettings/ParticipantsEventSettings/ParticipantsEventSettings';
import { TimeEventSettings } from 'src/domains/sportsbook/trading/view/eventDetails/eventSettings/TimeSettings/TimeSettings';
import { Feeds } from 'src/domains/sportsbook/trading/view/eventDetails/eventSettings/Feeds/Feeds';
import { AvailableOn } from 'src/domains/sportsbook/trading/view/eventDetails/eventSettings/AvailableOn/AvailableOn';
import { Grade } from 'src/domains/sportsbook/trading/view/eventDetails/eventSettings/Grade/Grade';
import { useAppStateContext } from 'src/AppState/AppState';
import { EventSettingsState } from 'src/domains/sportsbook/trading/view/eventDetails/eventSettings/EventSettings.state';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';

interface EventSettingsPropsTypes {
    eventId: EventId,
}

export const EventSettings = observer('EventSettings', (propsIn: EventSettingsPropsTypes) => {

    const [eventSettingsState] = useState(() => new EventSettingsState());
    const props = useAsObservableSource(propsIn);
    const { routerBackoffice, reduxAction } = useAppStateContext();
    
    const eventId = props.eventId;

    if (eventId === null) {
        console.error('EventSettings - eventId', eventId);
        return null;
    }


    return (
        <div className='event-settings form'>
            <div className='row'>
                <div className='col-4'>
                    <CompetitionEventName
                        eventId={eventId}
                    />
                    <ParticipantsEventSettings
                        eventId={eventId}
                        onSetErrorMessage={eventSettingsState.setErrorMessage}
                    />
                </div>
                <div className='col-8'>
                    <div className='row'>
                        <div className='col-8'>
                            <TimeEventSettings eventId={eventId} />
                        </div>
                        <div className='col-4'>
                            <Grade eventId={eventId} />
                            <section className='event-details-box'>
                                <a
                                    className='auditLink'
                                    onClick={
                                        (): void => {
                                            reduxAction.loadEventAudit(eventId);
                                            routerBackoffice.redirectToEventAudit(eventId);
                                        }
                                    }
                                    href='#'
                                >
                                    Audit
                                </a>
                            </section>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-6'>
                            <Feeds eventId={eventId} />
                        </div>
                        <div className='col-6'>
                            <AvailableOn
                                eventId={eventId}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {eventSettingsState.errorMessage !== null ? (
                <ul className={'error-box'}>
                    <li className='error-box__message'>
                        <a href='#' onClick={eventSettingsState.clearErrorMessage} />
                        {eventSettingsState.errorMessage}
                    </li>
                </ul>
            ) : null}
        </div>
    );
});
